export const USER_TYPES = {
  SYSTEM_USER: "system-user",
  STAFF: "staff",
  INSTITUTION_ADMIN: "institution_admin",
  CLIENT: "client",
  MASTER_ADMIN: "master_admin",
};
